module.exports = __webpack_public_path__ + "img/hero-ecart-seller.c2d10d3f.png";